/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MainPage from '../../MainPage';
import './Groups.less';
import ListItem from './ListItem';
import { message, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { getUserInfo } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { getProfilePics } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { getProfilePicUrl, getName } from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';
import { PhotoResolution, Actions } from '@vantiva-sa/homesight_humaui/Utilities/Constants';

const GroupsListView = (props) => {
  const {
    parentBread,
    setShowGroupModal,
    onActionClick,
    onGroupModalActionClick,
    action = null,
    refreshGroupList = false,
    useruuid,
    userInfo,
    isStaffAdmin,
    actionView,
  } = props;

  const header = parentBread || [];
  const [userGroups, setUserGroups] = useState([]);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [loading, setLoading] = useState(true);
  const resourcesMap = useSelector(getProfilePics());

  const userGroupApi = useSelector((state) => state.apis.userGroupApi);
  const trans = useSelector(translator);

  useEffect(() => {
    setLoading(true);
    // API callback definitions.
    const errorCallback = (error) => {
      // message.error("Error fetching user group !");
      console.error('Error fetching user group:', error);
    };
    const successCallback = (data) => {
      setLoading(false);
      if (data && data.usergroups) {
        setUserGroups(data.usergroups);
      }
    };

    try {
      userGroupApi.getUserGroups(
        { useruuid: useruuid },
        apiCallback({
          translator: trans,
          failCallback: errorCallback,
          errorCallback,
          successCallback,
        })
      );
    } catch (error) {
      errorCallback(error);
    }
  }, [refreshCounter, action, refreshGroupList]);

  const getInviteContacts = (invitedContacts) => {
    return invitedContacts?.map((contact) => {
      const url = getProfilePicUrl(contact.useruuid, resourcesMap, PhotoResolution.R64);
      const name = getName(contact.useruuid);
      return { profile_image_url: url, name, useruuid: contact.useruuid };
    });
  };

  return (
    <MainPage hasSider={false} header={header}>
      <div className="listgroup-wrapper page-content-wrapper">
        <div className="content-header" style={{ marginTop: '1rem', marginLeft: '0.2rem' }}>
          <div
            style={{
              display: 'flex',
              'justify-content': 'flex-start',
              padding: '10px 0 10px',
            }}
          >
            <div
              className={`item-count-container ${
                actionView === Actions?.viewPrinipalGroupDetails ? 'view-item-count-container' : ''
              }
               ${userGroups.length === 0 ? 'empty-groups-container' : ''}`}
            >
              <span className="item-count">{`Total (${userGroups.length})`}</span>
              <span className="group-list-subtitle">
                {trans('GROUPSHAVEBEENSORTEDBYALPHABETICALORDER')}
              </span>
            </div>
          </div>
        </div>

        <Spin spinning={loading} style={{ minWidth: '1200px', minHeight: '745px' }}>
          {loading ? null : userGroups.length === 0 ? (
            <div className="no-group-container">{trans('YOURGROUPPAGESEEMSEMPTY')}</div>
          ) : (
            <div
              className={`group-list ${
                actionView === Actions?.viewPrinipalGroupDetails ? 'group-tab-list' : ''
              }`}
            >
              {userGroups.map((group, index) => (
                <ListItem
                  key={group.groupuuid}
                  record={group}
                  title={group.name}
                  count={group.invited_contacts ? group.invited_contacts.length : 0}
                  onActionClick={onActionClick}
                  members={getInviteContacts(group.invited_contacts)}
                  actionView={Actions.viewPrinipalGroupDetails}
                />
              ))}
            </div>
          )}
        </Spin>
      </div>
    </MainPage>
  );
};

GroupsListView.propTypes = {
  parentBread: PropTypes.arrayOf(PropTypes.object),
  setShowGroupModal: PropTypes.func,
  onActionClick: PropTypes.func,
  onGroupModalActionClick: PropTypes.func,
};

export default GroupsListView;
